// extracted by mini-css-extract-plugin
module.exports = {"root":"all-activities-grid_root__2qL4q"};